import { useSelector } from "react-redux";
import { keepPreviousData, useQuery } from "@tanstack/react-query";

import { createAxiosInstance } from "api/axiosConfig";

export const STRIPE_PAYMENTS_QUERY_KEY = "stripePayments";

// GET api/practice/v1/{tenant}/payments — list/detail only, for the read-only
// "recent payments" panel on the payments settings page. Not for taking a
// payment (that flow lives in consultation/checkout, not here).
export const useStripePayments = ({
  page = 1,
  size = 20,
  status,
  from,
  to,
  enabled = true,
} = {}) => {
  const tenantVal =
    useSelector((state) => state.auth.user?.tenant) ||
    localStorage.getItem("kinesin-tenant");

  return useQuery({
    queryKey: [STRIPE_PAYMENTS_QUERY_KEY, tenantVal, page, size, status, from, to],
    queryFn: async () => {
      const axiosInstance = createAxiosInstance();

      const params = new URLSearchParams({
        page: String(page),
        size: String(size),
      });
      if (status) params.append("status", status);
      if (from) params.append("from", from);
      if (to) params.append("to", to);

      const response = await axiosInstance.get(
        `${tenantVal}/payments?${params.toString()}`
      );
      return response.data;
    },
    enabled: enabled && !!tenantVal,
    placeholderData: keepPreviousData,
  });
};
